import React from "react"
import "./table.css"

export default function SampleTable(props){
	return(
		<table>
			{props.children}
		</table>
	)
}